
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import settingx from '@/store/modules/settingx';
import Checkbox from 'primevue/checkbox';

@Component({
	components: { Checkbox },
})
export default class SlPhModuleOnlyToggle extends Vue {
	@Prop({ default: 'sales' }) public type!: 'sales' | 'purchase';

	public localSlPhModuleOnly: boolean = this.globalSlPhModuleOnly;

	public get label() {
		return this.type === 'purchase' ? 'Purchase Module Only' : 'Sales Module Only';
	}

	public get globalSlPhModuleOnly() {
		return settingx.now.slPhModuleOnly;
	}

	@Watch('localSlPhModuleOnly')
	public onLocalSlPhModuleOnlyChanged(newVal) {
		settingx.updateSettings({ slPhModuleOnly: newVal });
	}

	@Watch('globalSlPhModuleOnly')
	public onGlobalSlPhModuleOnlyChanged(newVal) {
		this.localSlPhModuleOnly = newVal;
	}
}
